/**
 * 文件说明:
 *
 * Page Header
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, useMemo} from 'react'
import ContentHeader from './components/content-header'
import ContentTabs from './components/content-tabs'

const typeMap = {
    header: ContentHeader,
    tabs: ContentTabs,
}

const PageHeader = memo((props) => {
    const {
        setHzHeaderHelp,
        pageProps,
        pageHeaderType,
        PageComponent,
        pageHeaderOption,
        restoreHzHeaderHelp,
        useTitle,
    } = props

    const Component = useMemo(() => typeMap?.[pageHeaderType], [pageHeaderType])

    if (!Component) {
        return (
            <PageComponent
                useTitle={useTitle}
                pageHeaderType={pageHeaderType}
                pageHeaderOption={pageHeaderOption}
                pageProps={pageProps}
                setHzHeaderHelp={setHzHeaderHelp}
                restoreHzHeaderHelp={restoreHzHeaderHelp}
            />
        )
    }

    return (
        <Component
            useTitle={useTitle}
            pageProps={pageProps}
            setHzHeaderHelp={setHzHeaderHelp}
            PageComponent={PageComponent}
            pageHeaderOption={pageHeaderOption}
            restoreHzHeaderHelp={restoreHzHeaderHelp}
        />
    )
})

export default PageHeader
